import { render, staticRenderFns } from "./AuthTemplate.vue?vue&type=template&id=d7afe646&scoped=true&"
import script from "./AuthTemplate.vue?vue&type=script&lang=js&"
export * from "./AuthTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7afe646",
  null
  
)

export default component.exports